import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Button from '../components/Button'

interface Props {
  onSearch: () => void
  onExport: () => void
}

export default class ReportButtons extends Component<Props> {
  render () {
    return (
      <div className="flex justify-end mt-1 gap-4">
        <Button
          text={i18n("Search")}
          onClick={this.props.onSearch} />
        <Button
          text={i18n("Export")}
          onClick={this.props.onExport} />
      </div>
    )
  }
}
